/**
 * The Design page's sections — one row of sub-tabs under the page header, each
 * deep-linkable as `/touchpoints/design?section=…`.
 *
 * Colours, brand assets, typography and shapes are four views of the *journey's*
 * theme and share one draft, so switching between them keeps unsaved work; files
 * is partner-wide (the uploaded files the theme and the emails point at) and
 * saves on its own. Layouts & building blocks were a section here too and are the
 * Email Center's Layout & Components tab now.
 */
export const THEME_SECTIONS = {
  COLORS: 'colors',
  BRAND: 'brand',
  TYPOGRAPHY: 'typography',
  SHAPES: 'shapes',
  FILES: 'files',
} as const;

export type ThemeSection = (typeof THEME_SECTIONS)[keyof typeof THEME_SECTIONS];

export const DEFAULT_THEME_SECTION: ThemeSection = THEME_SECTIONS.COLORS;

const SECTION_VALUES = Object.values(THEME_SECTIONS) as string[];

/** The sections backed by the journey theme draft (Save applies to all). */
export const THEME_DRAFT_SECTIONS: readonly ThemeSection[] = [
  THEME_SECTIONS.COLORS,
  THEME_SECTIONS.BRAND,
  THEME_SECTIONS.TYPOGRAPHY,
  THEME_SECTIONS.SHAPES,
];

export function isThemeDraftSection(section: ThemeSection): boolean {
  return THEME_DRAFT_SECTIONS.includes(section);
}

export function parseThemeSection(raw: string | null): ThemeSection {
  return SECTION_VALUES.includes(raw ?? '')
    ? (raw as ThemeSection)
    : DEFAULT_THEME_SECTION;
}
